<script setup lang="ts">
import {onMounted, ref} from 'vue'
import {Splide, SplideSlide, SplideTrack} from '@splidejs/vue-splide'
import '@splidejs/vue-splide/css'

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const props = defineProps({
	slides: {
		type: Object
	}
})

const splideOptions = {
	type      : 'loop',
	perPage   : 3,
	perMove   : 1,
	arrows: false,
	rewind: true,
	lazyLoad: 'sequential',
	drag: true,
	mediaQuery: 'min',
	gap: '1.5rem'
}

const isMobile = window.matchMedia('(max-width: 800px)')
const isTablet = window.matchMedia('(max-width: 1200px)')

const blogcarouselref = ref(null) as any

const handleMobileDesktopChange = () => {
	// Check if the media query is true
	if(blogcarouselref.value) {
		let hasMoreItems = false;
		if (isMobile.matches) {
			hasMoreItems = props.slides?.slides.length > 1;
			blogcarouselref.value.splide.options = {
				arrows: hasMoreItems,
				drag: hasMoreItems,
				perPage: 1
			}
		} else if(isTablet.matches) {
			hasMoreItems = props.slides?.slides.length > 2;
			blogcarouselref.value.splide.options = {
				arrows: hasMoreItems,
				drag: hasMoreItems,
				perPage: props.slides?.slides.length > 1 ? 2 : props.slides?.slides.length
			}
		} else {
			hasMoreItems = props.slides?.slides.length > 3;
			blogcarouselref.value.splide.options = {
				arrows: hasMoreItems,
				drag: hasMoreItems,
				perPage: props.slides?.slides.length > 2 ? 3 : props.slides?.slides.length
			}
		}
	}
}
isMobile.addEventListener('change', handleMobileDesktopChange)
isTablet.addEventListener('change', handleMobileDesktopChange)



onMounted(async () => {

	if(blogcarouselref.value) {

		blogcarouselref.value.splide.on('refresh', () => {
			handleMobileDesktopChange()
			blogcarouselref.value?.splide.event.emit('resize')
		})

		handleMobileDesktopChange()
	}
})
</script>

<template>
	<div>
		<Splide
			:has-track="false"
			:options="splideOptions"
			ref="blogcarouselref">
			<SplideTrack>
				<SplideSlide v-for="slide in props.slides?.slides" :key="slides?.key">
					<div class="flex flex-col h-full">
						<a :href="slide.cleanLink" class="overflow-hidden">
							<img
								:data-splide-lazy="`/Admin/Public/GetImage.ashx?Image=${slide.image}&Width=400&height=250&Format=webP&Quality=90&Crop=5&resolution=50`"
								:data-splide-lazy-srcset="`/Admin/Public/GetImage.ashx?Image=${slide.image}&Width=400&height=250&Format=webP&Quality=90&Crop=5&resolution=50 400w, /Admin/Public/GetImage.ashx?Image=${slide.image}&Width=800&height=500&Format=webP&Quality=90&Crop=5&resolution=50 800w, /Admin/Public/GetImage.ashx?Image=${slide.image}&Width=1600&height=1000&Format=webP&Quality=90&Crop=5&resolution=50 1600w`"
								sizes="100vw"
								:alt="slide.title"
								class="rounded-tr rounded-tl w-full object-cover object-center aspect-16/10">
						</a>
						<div class="flex flex-col justify-center items-center grow gap-4 p-4 xl:p-8 text-center bg-white rounded-br rounded-bl">
							<h3>{{ slide.title }}</h3>
							<a :href="slide.cleanLink" class="text-black underline text-sm mt-auto hover:no-underline hover:text-black">{{slide.readMoreText}}</a>
						</div>
					</div>
				</SplideSlide>
			</SplideTrack>

			<div class="splide__pagination relative hidden"></div>

			<div class="splide__arrows">
				<button class="splide__arrow splide__arrow--prev -left-4"><font-awesome-icon :icon="['fal', 'chevron-right']" /></button>
				<button class="splide__arrow splide__arrow--next -right-4"><font-awesome-icon :icon="['fal', 'chevron-right']" /></button>
			</div>
		</Splide>
	</div>
</template>

<style>
/* Overruling Splide defaults */
button.splide__pagination__page {
	@apply h-2 w-12 transition rounded-sm m-0 opacity-100 bg-grey hover:bg-grey-dark/90;
}
button.splide__pagination__page.is-active {
	@apply bg-grey-dark scale-100;
}
</style>
